import $ from 'jquery';

$(document).on('blur', '.input input[type=text], .input input[type=email], .input input[type=tel], .input input[type=number], .input textarea', function () {
    if ($(this).val() != "") {
        $(this).parent('.input').addClass('input--filled');
    } else {
        $(this).parent('.input').removeClass('input--filled');
    }
})


// WEBPACK FOOTER //
// ./nette/NetteFormFilled/index.js